import React from "react";
function AayurcareTerms({goBack}) {
  return (
    <div className="aayurcareterms-section">


        {/* <button onClick={goBack} className="back-btn">
        ← Go Back
      </button> */}


        <h1>Terms and Conditions</h1>
        <p>Effective Date</p>
        <p>May 20,2025</p>

        <h3>Acceptance of Terms</h3>
        <p> By accessing or using our website and services, you acknowledge that you have read, understood, and agreed to be
 bound by these Terms and our Privacy Policy. Non-acceptance of any provision of these Terms requires immediate
 cessation of service usage. These Terms constitute an electronic record as per the provisions of the Information
 Technology Act, 2000 and applicable rules, and do not require any physical or digital signature.</p>


 <h3>Eligibility</h3>
 <p> You must be at least 18 years old and legally competent to enter into a binding agreement under the Indian Contract Act,
 1872, to use our services. Aayur Care’s services are not intended for use by children under the age of 16. Users aged
 between 16 and 18 may use the services only with the involvement and consent of a parent or legal guardian. If you are
 accessing the services on behalf of a company or other legal entity, you confirm that you have the authority to bind that
 entity to these Terms</p>

 <h3>Service Overview</h3>
 <p>Aayur Care provides medical reimbursement membership plans and related services through digital and offline
 platforms. All users are strictly required to provide accurate, complete, and current information as requested by the
 Company. Failure to do so may result in suspension or termination of access to the Service.</p>

 <h3> Use of the Website and Services</h3>
 <p> By using the Service, you expressly agree and undertake that you will:
 Not use the Service for any unlawful, fraudulent, or unauthorized purpose.
 Not attempt, directly or indirectly, to gain unauthorized access to the Service, its systems, networks, accounts, or data.
 Not engage in any conduct that disrupts, compromises, or interferes with the security, integrity, operation, or availability
 of the Service.

 Any breach of these obligations may result in immediate termination of your access to the Service, legal action, and
 liability for damages to the fullest extent permitted by law.We reserve the right to suspend or terminate access to users
 who violate these Terms or misuse our services.
</p>

<h3>Payments and Reimbursement</h3>
<p>Payments for services or plans shall be made in Indian Rupees (INR) through authorized payment methods. All
 transactions are subject to applicable taxes as per Indian laws.
 <br></br>
 Please note that no refunds are applicable for the services or plans purchased. Reimbursements, if any, will be made
 strictly in accordance with the Company’s Reimbursement Policy</p>


 <h3>Privacy</h3>
 <p> Your use of the Service is governed by our Privacy Policy, which complies fully with the Information Technology
 (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011, and all
 applicable Indian data protection laws.
 <br></br>
 We are committed to maintaining the confidentiality, integrity, and security of your personal data and medical records.
 We implement robust technical and organizational measures to protect your sensitive information from unauthorized
 access, disclosure, alteration, or destruction, in accordance with applicable legal requirements.
 <br></br>
 By using our Service, you consent to the collection, processing, and storage of your personal and medical data as
 described in our Privacy Policy.</p>

 <h3> Third-Party Services</h3>
 <p> Our website and services may include links or access to third-party websites, applications, or services that are not owned,
 controlled, or operated by Aayur Care. We expressly disclaim any responsibility or liability for the content, accuracy,
 practices, or policies of these third parties.
 <br></br>
 By accessing such third-party websites or services through our platform, you acknowledge and agree that your use of
 them is at your own risk. We strongly advise you to carefully review the terms of use, privacy policies, and any other
 applicable agreements of these third-party providers before engaging with their services.</p>

 <h3>Limitation of Liability</h3>
 <p> To the fullest extent permitted under applicable Indian laws, Aayur Care and its affiliates, officers, employees, agents,
 and partners shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including but not
 limited to loss of data, revenue, business, profits, goodwill, or anticipated savings, arising out of or in connection with
 your use of or inability to use our services, regardless of the legal theory or cause of action, even if we have been
 advised of the possibility of such damages.
 <br></br>
 Our total aggregate liability under or related to these Terms shall not exceed the amount you have paid to us, if any, for
 the specific service that gave rise to the claim.
 <br></br>
 This limitation applies even if any exclusive remedy fails its essential purpose.
</p>

<h3>Disclaimer</h3>
<p>Our services are provided on an “as is” and “as available” basis, without any warranties or representations, express or
 implied, regarding their suitability, reliability, accuracy, or availability. To the maximum extent permitted by applicable
 law, Aayur Care expressly disclaims all warranties, including but not limited to warranties of merchantability, fitness for
 a particular purpose, and non-infringement.</p>
 <br></br>
  While Aayur Care's medical professionals and affiliated doctors are qualified and experienced, any medical advice,
 recommendations, or information provided through our services is intended for general informational purposes only.
 Users are strongly encouraged to consult their primary physician or seek a second opinion from another qualified
 healthcare provider before making any medical decisions based on such advice


 <h3>Indemnity</h3>
 <p> You agree to indemnify, defend, and hold harmless Aayur Care, its affiliates, officers, directors, employees, and agents
 from any and all claims, damages, losses, liabilities, and expenses (including reasonable legal fees) arising from:

 <br></br>

 Your breach of these Terms

 <br></br>

  Your misuse or unauthorized use of the services

  <br></br>

   Your violation of any applicable laws or third-party rights

   <br></br>

    You agree to cooperate fully with Aayur Care in defending any such claims and not to settle any matter without Aayur
 Care’s prior written consent.


 <h3> Governing Law and Jurisdiction</h3>
 <p>These Terms shall be governed by, interpreted, and enforced in accordance with the laws of India, without regard to
 conflict of law principles. Any dispute, controversy, or claim arising out of or relating to these Terms, the breach thereof,
 or your use of Aayur Care’s services shall be subject to the exclusive jurisdiction of the competent courts at Bangalore,
 Karnataka</p>

 <br></br>

 You hereby irrevocably submit to the jurisdiction of such courts and waive any objection to the laying of venue or
 inconvenience of forum in such courts
 </p>



 <h3>Changes to Terms</h3>
 <p>Aayur Care reserves the right to revise, modify, or update these Terms at any time, at its sole discretion, without prior
 notice. Any such changes shall become effective upon being posted on our official website. Your continued access or
 use of our services after any such modifications shall constitute your acknowledgment and acceptance of the revised
 Terms. Aayur Care shall not be liable for any loss or inconvenience resulting from your failure to review such changes</p>


 <h3>Severability</h3>
 <p> If any provision of these Terms is found to be unlawful, void, or unenforceable under applicable Indian law, such
 provision shall be deemed severed from these Terms and shall be replaced with a valid, enforceable provision that most
 closely reflects the original intent of the parties. The remainder of these Terms shall continue in full force and effect and
 shall not be affected or impaired in any way</p>


 <h3> Grievance Redressal</h3>
 <p> In compliance with the Information Technology Act, 2000 and rules thereunder, the name and contact details of the
 Grievance Officer are provided below</p>


<h3> Grievance Office</h3>
<p> Email: grievance@aayurcare.com
    <br></br>
    Phone: +91 7338146712
    Address: BHIVE Premium Koramangala (Near Nexus Mall), Hosur Main Road, next to Forum Mall, Adugodi,
 Koramangala, Bengaluru, Karnataka, India
</p>



<h3>Contact Information</h3>
<p> For questions or concerns regarding these Terms, please contact</p>
<br></br>
<br></br>
Aayur Care
<br></br>
Website: www.aayurcare.com
<br></br>
Email:contact@aayurcare.com
<br></br>
Phone: +91 7338146712
<br></br>
 Registered Office: Crescent Workspace, next to Karnataka Bank, HRBR Layout 1st Block, Bank Avenue Colony,
 Banaswadi, Bengaluru, Karnataka– 560043, India.
 <br></br>
  Operating Address : BHIVE Premium Koramangala (Near Nexus Mall), Hosur Main Road, next to Forum Mall,
 Adugodi, Koramangala, Bengaluru, Karnataka, Indi


 













      
    
    </div>
  );
}

export default AayurcareTerms
